import {useState} from "react";
import instance from "../../index";
import {ReferenceDto} from "../../../models/reference-operating-hour-dto";
import {CreateReferenceWithOperatingHoursCommand} from "../../../models/create-reference-with-operating-hours-command";
import {UpdateReferenceCommand} from "../../../models/update-reference-operating-hour-command";
import {ReferenceFilters} from "../../../models/reference-filters";
import {PagedList} from "../../../models/paged-list";
import {BaseResponse} from "../../../models/base-response";
import {ShortDto} from "../../../models/short-dto";

const useReferenceService = () => {
    const [loading, setLoading] = useState<boolean>(false);

    async function createReferenceWithOperatingHours(command: CreateReferenceWithOperatingHoursCommand): Promise<ReferenceDto> {
        setLoading(true);
        const response = await instance.post<ReferenceDto>('/v1/backoffice/references', command);
        setLoading(false);
        return response.data;
    }

    async function updateReference(id: string, command: UpdateReferenceCommand): Promise<ReferenceDto> {
        setLoading(true);
        const response = await instance.put<ReferenceDto>(`/v1/backoffice/references/${id}`, command);
        setLoading(false);
        return response.data;
    }

    async function deleteReference(id: string): Promise<ReferenceDto> {
        setLoading(true);
        const response = await instance.delete<ReferenceDto>(`/v1/backoffice/references/${id}`);
        setLoading(false);
        return response.data;
    }

    async function activateReference(id: string): Promise<ReferenceDto> {
        setLoading(true);
        const response = await instance.put<ReferenceDto>(`/v1/backoffice/references/${id}/activate`);
        setLoading(false);
        return response.data;
    }

    async function deactivateReference(id: string): Promise<ReferenceDto> {
        setLoading(true);
        const response = await instance.put<ReferenceDto>(`/v1/backoffice/references/${id}/deactivate`);
        setLoading(false);
        return response.data;
    }

    async function getReferences(filter?: ReferenceFilters): Promise<PagedList<ReferenceDto>> {
        const response = await instance.get<BaseResponse<PagedList<ReferenceDto>>>("/v1/backoffice/references", {params: filter});
        return response?.data?.data;
    }

    async function getReferenceById(id: string) {
        const response = await instance.get<BaseResponse<ReferenceDto>>(`/v1/backoffice/references/${id}`);
        return response?.data?.data;
    }

    async function getReferencesShort(): Promise<ShortDto[]> {
        setLoading(true);
        const response = await instance.get<BaseResponse<ShortDto[]>>("/v1/backoffice/references/short");
        setLoading(false);
        return response?.data?.data;
    }



    return {
        loading,
        createReferenceWithOperatingHours,
        updateReference,
        deleteReference,
        activateReference,
        deactivateReference,
        getReferences,
        getReferenceById,
        getReferencesShort
    };
};

export default useReferenceService;
